export default __webpack_public_path__ + "static/media/folder.33e80eae.svg";